import Seo from "../components/Seo";
import PageHero from "../components/PageHero";
import ReviewsSection from "../components/ReviewsSection";
import CtaBand from "../components/CtaBand";

const Recensioni = () => (
  <>
    <Seo
      title="Recensioni dei clienti | Avv. Manfredi Bruno, Palermo"
      description="Le recensioni dei clienti dello Studio Legale Avv. Manfredi Bruno a Palermo, pubblicate e verificabili sul Profilo dell'attività Google."
      path="/recensioni"
    />
    <PageHero
      kicker="Recensioni"
      title="Le recensioni dei clienti"
      intro="La fiducia di chi è stato assistito dallo studio è il riconoscimento più importante. Le recensioni sono pubblicate sul Profilo dell'attività Google, dove chiunque può leggerle e verificarne l'autenticità."
      breadcrumb="Recensioni"
    />
    <ReviewsSection standalone />
    <CtaBand />
  </>
);

export default Recensioni;
